import { Observable } from 'rxjs';
import { setBaggageEntriesOnContext } from '@candyland/generic/shared/util-tracing';
import { context } from '@opentelemetry/api';
import { ALLOWED_TO_ERROR } from '@candyland/angular/shared/util-tracing';

export class PianoHelper {
  // Checks if the piano script is blocked by the browser, solution provided by Piano
  /**
   * Checks if Piano's domain is blocked by the browser or network.
   * Makes a HEAD request to Piano's domain and checks if it succeeds.
   * Times out after 5 seconds.
   * @param httpClient - Angular HttpClient instance
   * @returns Observable<boolean> - true if blocked, false if accessible
   */
  public static readonly isPianoBlocked$ = new Observable<boolean>((observer) => {
    const ctx = setBaggageEntriesOnContext(context.active(), {
      [ALLOWED_TO_ERROR]: 'true',
    });
    const domain = 'https://c2-eu.piano.io/xbuilder/experience/execute';
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    context.with(ctx, async () =>
      fetch(domain, {
        method: 'HEAD', // Use HEAD to minimize data transfer
        signal: controller.signal,
      })
        .then(() => {
          clearTimeout(timeoutId);
          observer.next(false);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log(`Request timed out - '${domain}' may be blocked`);
          } else {
            console.log(`'${domain}' is blocked`);
          }
          observer.next(true);
        })
        .finally(() => {
          observer.complete();
        })
    );
  });
}
